"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Styles = require("./search-legend.styles");
exports.SearchLegend = function SearchLegend(props) {
    return (React.createElement(Styles.StyledSearchLegend, { className: props.className },
        props.name && React.createElement(Styles.StyledLegendName, null, props.name),
        React.createElement(Styles.StyledSearchLegendBox, null, props.items.map(field => {
            return (React.createElement(Styles.StyledField, { key: field.key },
                React.createElement(Styles.StyledFieldLink, { title: field.description, query: { search: field.value } }, field.key)));
        }))));
};
//# sourceMappingURL=search-legend.js.map